import { createContext } from 'react';

const PortalContext = createContext();

export default PortalContext;